<!-- @format -->

<ng-container *transloco="let t">
  @for (expirationInfo of expirationInfos$ | async; track studyRightId($index, expirationInfo)) {
    <fudis-notification variant="warning" class="d-block alert-top-spacing">
      <fudis-body-text class="sis-mt-xxs">
        <fudis-body-text>
          {{
            t("STUDY_RIGHT_EXPIRATION.EXPIRING_INFO_WITH_EDUCATION", {
              educationName: expirationInfo.studyRight.educationId | education | async | localizeProperty: "name",
              endDate: expirationInfo.inclusiveEndDate | localDateFormat,
            })
          }}
        </fudis-body-text>
      </fudis-body-text>
      <fudis-body-text>
        {{ t("STUDY_RIGHT_EXPIRATION.EXTENSION_INFO_EXPIRING") }}
      </fudis-body-text>
      @if (extensionApplicationEnabled() && !expirationInfo.pendingExtensionApplication) {
        <sis-button
          [label]="t('STUDY_RIGHT_EXPIRATION.EXTENSION_APPLY')"
          [link]="true"
          (clicked)="applyForExtension(expirationInfo.studyRight)"
          class="d-inline-block sis-m-xxs"
          data-cy="study-right-expiration-info-apply-for-extension" />
      }
      @if (expirationInfo.pendingExtensionApplication) {
        <a
          fudisLink
          uiSref="student.logged-in.profile.applications.study-right-extension-workflow"
          [uiParams]="{ applicationId: expirationInfo.pendingExtensionApplication.id }"
          [title]="t('STUDY_RIGHT_EXPIRATION.EXTENSION_SHOW_APPLICATION')"
          class="d-inline-block sis-m-xxs"
          data-cy="study-right-expiration-info-show-application"></a>
      }
    </fudis-notification>
  }
</ng-container>
